export const brand = {
	"response": {
		"code": "1",
		"errorCode": "0000",
		"message": null
	},
	"data": {
		"version": {
			"version": 1,
			"last_up_time": "2017-05-23T14:45:38.2575958+08:00",
			"expired": 7200
		},
		"value": [{
			Code:'sZSa8iOZ7T',
			Name:'我们是谁? ? ?',
			Items:[{
				Code:'KaaKAzhIiF',
				Name:'一家精油公司一次一滴地改变着世界',
				Url:'',
			}]
		},{
			Code:'AKOLqIHIsf',
			Name:'我们所能做的? ? ?',
			Items:[{
				Code:'DUI6EUTF14',
				Name:'提供最纯净、最优质的精油和产品。',
				Url:'',
			}]
		},{
			Code:'T3VH685DlJ',
			Name:'我们为什么这么做? ? ?',
			Items:[{
				Code:'LwZW0kFoP4',
				Name:'让你和你所爱的人拥有健康和健康。',
				Url:'',
			}]
		},{
			Code:'TvW4L3ShSS',
			Name:'关于多特瑞',
			Items:[{
				Code:'simHnp3dXV',
				Name:'关于我们',
				Url:'',
			},{
				Code:'kaToMCEcfl',
				Name:'媒体新闻',
				Url:'',
			},{
				Code:'MrAao8hFvd',
				Name:'创办人介绍',
				Url:'',
			}]
		},{
			Code:'K1oShFh6ks',
			Name:'多特瑞精油',
			Items:[{
				Code:'1YHLkZEf5H',
				Name:'什么是精油',
				Url:'',
			},{
				Code:'9kExFBrA7J',
				Name:'如何使用精油',
				Url:'',
			}]
		},{
			Code:'r4duf3JiSO',
			Name:'doTERRA Difference',
			Items:[{
				Code:'xCRtsOW0DW',
				Name:'从来源到你',
				Url:'',
			},{
				Code:'BFoXAevfd6',
				Name:'CPTG质量检测',
				Url:'',
			},{
				Code:'pd5GTgj4vo',
				Name:'关于携手关爱',
				Url:'',
			},{
				Code:'iZDibdkwdX',
				Name:'互惠合作采购计划',
				Url:'',
			},{
				Code:'0CgsoVcgfy',
				Name:'疗愈之手',
				Url:'',
			},]
		}]
	}
}



